<div class="reset-password-container">
    <form #resetPasswordForm="ngForm" class="form-reset-password" (ngSubmit)="resetPasswordForm.form.valid
    && resetPassword()" novalidate>
        <h1 class="h3 mb-3 font-weight-normal">Reset Password</h1>
        <p>Enter your new password to reset the password for your account.</p>
        <div class="form-group">
             <label for="password">Password *</label>
             <input type="password" class="form-control" id="password"
                    required
                    minlength="10"
                    appPasswordComplexity
                    placeholder="Enter a password"
                    [(ngModel)]="passwordResetRequest.newPassword" name="password"
                    #password="ngModel">
             <div *ngIf="password.invalid && (password.dirty || password.touched)" class="alert alert-danger">
                 <div *ngIf="password.errors.required">
                     Password is required
                 </div>
                 <div *ngIf="password.errors.minlength">
                     Password must be at least 10 characters long.
                 </div>
                 <div>
                     {{ password.errors.passwordComplexity }}
                 </div>
             </div>
        </div>
        <div class="form-group">
             <label for="confirmPassword">Confirm password *</label>
             <input type="password" class="form-control" id="confirmPassword"
                    required
                    placeholder="Enter a password"
                    name="confirmPassword"
                    [(ngModel)]="passwordCheck"
                    #confirmPassword="ngModel"
                    pattern="{{ passwordResetRequest.newPassword }}">
             <div *ngIf="confirmPassword.invalid && (confirmPassword.dirty || confirmPassword.touched)" class="alert alert-danger">
                 <div *ngIf="confirmPassword.errors.required">
                     Confirm your password
                 </div>
                 <div *ngIf="confirmPassword.errors.pattern">
                     Password and confirm password must match.
                 </div>
             </div>
        </div>
        <!-- GENERIC ERROR -->
        <div class="form-group" *ngIf="passwordResetFail">
            <div class="alert alert-danger">
                Something went wrong. Please try again.
                If the problem persists, please <a routerLink="/contact">contact us</a>.
            </div>
        </div>
        <!-- SUCCESS -->
        <div class="form-group" *ngIf="passwordResetSuccess">
            <div class="alert alert-primary">
               Your password has been reset successfully.
            </div>
            <div>
                <button class="btn btn-primary" routerLink="/login">Login</button>
            </div>
        </div>
        <div class="form-group">
            <button class="btn btn-lg btn-primary btn-block" type="submit"
                    [disabled]="!resetPasswordForm.form.valid || passwordResetSuccess">
                Reset password
            </button>
        </div>
    </form>
</div>